import { Trans } from "@lingui/macro";
import { UiBox, UiTextFieldSearch } from "@smp/ui";
import { ChangeEvent } from "react";

import { useContextStickers } from "../../../../context";

export const SearchBar = () => {
  const {
    state: { searchString },
    actions: { setSearchString },
  } = useContextStickers();

  const handleChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setSearchString(e.target.value);
  };

  return (
    <UiBox mb={2.5}>
      <UiTextFieldSearch
        fullWidth
        variant="outlined"
        label={<Trans>Search stickers</Trans>}
        value={searchString}
        onChange={handleChange}
        debounce={500}
      />
    </UiBox>
  );
};
